module.exports = __webpack_public_path__ + "img/wechat-qrcode.2d1ea5e.jpg";